import { createActions, createReducer } from 'reduxsauce'

import UnidadeMedidaIndicadoresService from '../servicos/UnidadeMedidaIndicadoresService'
/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaUnidadeMedidaInicio: [],
    buscaUnidadeMedidaSucesso: ['unidadeMedida'],
    buscaUnidadeMedidaErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaUnidadeMedida = () => {
    return dispatch => {
        dispatch(Creators.buscaUnidadeMedidaInicio())
        let serv = new UnidadeMedidaIndicadoresService()
        return serv
            .getUnidadeMedida()
            .then(response => dispatch(Creators.buscaUnidadeMedidaSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaUnidadeMedidaErro(error)))
    }
}

const buscaUnidadeMedidaInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaUnidadeMedidaErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaUnidadeMedidaSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.unidadeMedida, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_UNIDADE_MEDIDA_INICIO]: buscaUnidadeMedidaInicio,
    [Types.BUSCA_UNIDADE_MEDIDA_ERRO]: buscaUnidadeMedidaErro,
    [Types.BUSCA_UNIDADE_MEDIDA_SUCESSO]: buscaUnidadeMedidaSucesso,
})
